import { UserRole } from "@excel-center/shared";
import { lazy } from "react";
import { createBrowserRouter, type RouteObject } from "react-router";
import { aiAssistantRoutes } from "@/src/ai-assistant/navigations/ai-assistant-routes";
import { analyticsRoutes } from "@/src/analytics/navigations/analytics-routes";
import { auditRoutes } from "@/src/audit/navigations/audit-routes";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { authProtectedRoutes, authPublicRoutes, authStandaloneRoutes } from "@/src/auth/navigations/auth-routes";
import { childcareRoutes } from "@/src/childcare/navigations/childcare-routes";
import { AuthedLayout } from "@/src/common/layouts/authed-layout";
import { PublicLayout } from "@/src/common/layouts/public-layout";
import { HomeRedirect } from "@/src/common/navigations/home-redirect";
import { dashboardRoutes } from "@/src/dashboard/navigations/dashboard-routes";
import { groupsAuthedRoutes } from "@/src/groups/navigations/groups-routes";
import { jobsAuthedRoutes, jobsPublicRoutes } from "@/src/jobs/navigations/jobs-routes";
import { messagingAuthedRoutes } from "@/src/messaging/navigations/messaging-routes";
import { postAuthedRoutes, postPublicRoutes } from "@/src/post/navigations/post-routes";
import { profileStudentRoutes } from "@/src/profile/navigations/profile-routes";
import { reportsRoutes } from "@/src/reports/navigations/reports-routes";
import { resumeStudentRoutes } from "@/src/resume/navigations/resume-routes";
import { schoolsAuthedRoutes } from "@/src/schools/navigations/schools-routes";
import { SETTINGS_ROUTES } from "@/src/settings/settings-routes.constants";
import { staffsRoutes } from "@/src/staffs/navigations/staffs-routes";
import { studentCentralAuthedRoutes, studentCentralPublicRoutes } from "@/src/student-central/navigations/student-central-routes";
import { studentsRoutes } from "@/src/students/navigations/students-routes";

const NotFoundPage = lazy(() => import("@/src/common/pages/not-found-page"));
const SettingsPage = lazy(() => import("@/src/settings/settings.page"));

const publicRoutes: RouteObject[] = [...authPublicRoutes, ...jobsPublicRoutes, ...postPublicRoutes, ...studentCentralPublicRoutes];

const authedRoutes: RouteObject[] = [
	{ path: SETTINGS_ROUTES.settings, element: <SettingsPage /> },
	...dashboardRoutes,
	...jobsAuthedRoutes,
	...postAuthedRoutes,
	...staffsRoutes,
	...studentsRoutes,
	...studentCentralAuthedRoutes,
	...schoolsAuthedRoutes,
	...groupsAuthedRoutes,
	...messagingAuthedRoutes,
	...analyticsRoutes,
	...aiAssistantRoutes,
	...auditRoutes,
	...reportsRoutes,
	...childcareRoutes,
];

export const rootRouter = createBrowserRouter([
	{ path: "/", element: <HomeRedirect /> },
	{
		element: <AuthedLayout />,
		children: [
			{
				element: <ProtectedRoute />,
				children: authedRoutes,
			},
			{
				element: <ProtectedRoute requiredRole={UserRole.STUDENT} />,
				children: [...profileStudentRoutes, ...resumeStudentRoutes],
			},
		],
	},
	{
		element: <PublicLayout />,
		children: [...publicRoutes, ...authProtectedRoutes],
	},
	...authStandaloneRoutes,
	{ path: "*", element: <NotFoundPage /> },
]);
